// Defs das tags/buckets conhecidos do CRM.
// `lote` = tags organizacionais (recorte de trabalho). `bucket` = classificação de
// abordagem gerada pelo enriquecimento (Camada 2).

export type TagKind = 'lote' | 'bucket';

export interface TagDef {
  slug: string;
  label: string;
  tone: string; // classes Tailwind (mesmo padrão do ScoreBadge)
  kind: TagKind;
}

const TONE = {
  emerald: 'border-emerald-500/40 bg-emerald-50 text-emerald-900 dark:bg-emerald-950 dark:text-emerald-200',
  amber: 'border-amber-500/40 bg-amber-50 text-amber-900 dark:bg-amber-950 dark:text-amber-200',
  slate: 'border-slate-300 bg-slate-50 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  violet: 'border-violet-500/40 bg-violet-50 text-violet-900 dark:bg-violet-950 dark:text-violet-200',
  orange: 'border-orange-500/40 bg-orange-50 text-orange-900 dark:bg-orange-950 dark:text-orange-200',
  lote: 'border-primary/40 bg-primary/10 text-primary',
} as const;

export const TAG_DEFS: TagDef[] = [
  { slug: 'lote-1', label: 'Lote 1', tone: TONE.lote, kind: 'lote' },
  { slug: 'piloto-comercio-30', label: 'Piloto 30', tone: TONE.lote, kind: 'lote' },
  { slug: 'investe-sem-agencia', label: 'investe sem agência', tone: TONE.emerald, kind: 'bucket' },
  { slug: 'ja-estruturado', label: 'já estruturado', tone: TONE.amber, kind: 'bucket' },
  { slug: 'presenca-zero', label: 'presença zero', tone: TONE.slate, kind: 'bucket' },
  { slug: 'anuncia', label: 'anuncia', tone: TONE.violet, kind: 'bucket' },
  { slug: 'site-sem-rastreio', label: 'site s/ rastreio', tone: TONE.orange, kind: 'bucket' },
];

export const TAG_BY_SLUG: Map<string, TagDef> = new Map(TAG_DEFS.map((d) => [d.slug, d]));

const NEUTRO = 'border-border bg-muted text-muted-foreground';

/** Resolve a def de uma tag; tags desconhecidas recebem visual neutro. */
export function tagDef(slug: string): TagDef {
  return TAG_BY_SLUG.get(slug) ?? { slug, label: slug, tone: NEUTRO, kind: 'bucket' };
}
